import type { UiSchema, WidgetProps, RJSFSchema } from "@rjsf/utils";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { KioDateTimePickerProps } from "../common/KioDateTimePicker";
import KioDateTimePicker from "../common/KioDateTimePicker";
import { getValueFromUiSchema } from "@/utils/schema";

export interface KioDateTimeWidgetProps extends WidgetProps {
  onChange: (date: string | undefined | null) => void;
}

function getTimePickerType(schema: RJSFSchema): any {
  if (schema.format && ["date-time", "date", "time"].includes(schema.format)) {
    return schema.format as KioDateTimePickerProps["timePickerType"];
  }
  return "date-time";
}

function getTitle(schema: RJSFSchema, uiSchema: UiSchema): string {
  return schema.title ?? getValueFromUiSchema("title", uiSchema) ?? getValueFromUiSchema("label", uiSchema) ?? "";
}

function getDescription(schema: RJSFSchema, uiSchema: UiSchema): string | undefined {
  return schema.description ?? getValueFromUiSchema("description", uiSchema);
}

const KioDateTimeWidget: FC<KioDateTimeWidgetProps> = ({
  schema,
  uiSchema,
  id,
  value,
  onChange,
  disabled,
  readonly,
}) => {
  const { t } = useTranslation("common");
  const title = uiSchema ? getTitle(schema, uiSchema) : "";
  const description = uiSchema ? getDescription(schema, uiSchema) : "";
  const timePickerType = uiSchema ? getTimePickerType(schema) : "";

  return (
    <KioDateTimePicker
      timePickerType={timePickerType}
      name={id}
      description={description}
      formValue={value || null}
      onChange={onChange}
      label={title}
      cancelLabel={t("generic.cancel")}
      okLabel={t("generic.ok")}
      clearLabel={t("generic.clear")}
      todayLabel={t("generic.today")}
      invalidDateMessage={t("kioForm.common.kioDateTimePicker.error.invalidDateMessage")}
      disabled={disabled || readonly}
    />
  );
};

export default KioDateTimeWidget;
